var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"chart-data-table",attrs:{"headers":_vm.headers,"items":_vm.formattedRows,"footer-props":{
    disableItemsPerPage: true,
    itemsPerPageOptions: [this.itemsPerPage],
  },"dense":""},scopedSlots:_vm._u([{key:"body.append",fn:function({ headers }){return [_c('tr',{staticClass:"totals"},_vm._l((_vm.totals),function(total,i){return _c('th',{key:i,staticClass:"text-right"},[(headers[i]['value'] !== _vm.primaryDimension)?_c('span',[_vm._v(_vm._s(_vm.formatInteger(total)))]):_c('span',[_vm._v(_vm._s(_vm.$t("total")))])])}),0)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }